import { render, staticRenderFns } from "./SliderSkeleton.vue?vue&type=template&id=799d075b&scoped=true"
import script from "./SliderSkeleton.vue?vue&type=script&lang=js"
export * from "./SliderSkeleton.vue?vue&type=script&lang=js"
import style0 from "./SliderSkeleton.vue?vue&type=style&index=0&id=799d075b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d075b",
  null
  
)

export default component.exports